import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { selectIsAuthenticated, selectIsSuperAdmin, useAuthStore } from '@/stores/authStore'

/** Gate a route behind authentication; remembers the target in location state. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const location = useLocation()
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}

/** Redirect authenticated users away from public-only pages (e.g. /login). */
export function PublicOnly({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  if (isAuthenticated) {
    return <Navigate to="/desk" replace />
  }
  return <>{children}</>
}

/** Gate a route behind the super_admin role. */
export function RequireSuperAdmin({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const isSuperAdmin = useAuthStore(selectIsSuperAdmin)
  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (!isSuperAdmin) return <Navigate to="/desk" replace />
  return <>{children}</>
}
